// context
import { useContext } from "react";
import { CartContext } from "../context/CartContext";

export default function Qty({ item }) {
  const { handleInput, handleSelect } = useContext(CartContext);
  const selectId = `qty-${item._id}`;
  return (
    <div className="flex gap-x-6 items-center">
      <label htmlFor={selectId} className="sr-only">
        Quantity for {item.title}
      </label>
      {item.amount < 10 ? (
        <select
          id={selectId}
          onChange={(e) => handleSelect(e, item._id)}
          value={item.amount}
          className="p-2 rounded-btn w-[100px] h-12 outline-none text-ink bg-canvas border border-border focus:border-brand focus:ring-2 focus:ring-brand/20 transition">
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10+</option>
        </select>
      ) : (
        <input
          id={selectId}
          onBlur={(e) => handleInput(e, item._id)}
          className="text-ink placeholder:text-muted h-12 rounded-btn p-4 w-[120px] bg-canvas border border-border outline-none focus:border-brand focus:ring-2 focus:ring-brand/20 transition"
          type="text"
          placeholder={`${item.amount}`}
        />
      )}
    </div>
  );
}
